import React, { useEffect, useState } from "react";
import Layout from "../../../Components/Layout";
import { Icon } from "@iconify/react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

// const teamData = {
//   teamName: "Frontend Team",
//   createdOn: "26 Nov '25, 2:35PM",
//   updatedOn: "26 Nov '25, 2:35PM",
//   owner: {
//     name: "Atul Thakur",
//     email: "atul@raksoftech.com",
//     phone: "+91 12345 67890",
//   },
//   members: Array.from({ length: 11 }).map((_, i) => ({
//     name: "Atul Thakur",
//     email: "atul@raksoftech.com",
//     phone: "+91 12345 67890",
//   })),
// };

function TeamView() {
  const { id } = useParams();
  const navigate = useNavigate();
  // State for team data
  const [teamData, setTeamData] = useState(null);

  const token = localStorage.getItem("token");

  // Fetch employee list
  useEffect(() => {
    const featchuser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/teams/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setTeamData(response?.data);
        console.log(response?.data, "team view data ");
      } catch (error) {
        console.error("Error creating team:", error);
      }
    };
    featchuser();
  }, [id, token]);

  if (!teamData) {
    return (
      <Layout>
        <div className="backgound-main-content p-3">Loading team data...</div>
      </Layout>
    );
  }

  const formatDateTime = (isoString) => {
    if (!isoString) return "";
    return new Date(isoString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const { teamName, teamOwner, teamMembers, createdAt, updatedAt } = teamData;
  return (
    <Layout>
      <div className="backgound-main-content">
        {/* Header with background */}
        <Icon
          icon="material-symbols:arrow-back-rounded"
          width="24"
          height="24"
          style={{ cursor: "pointer", marginBottom: "3px" }}
          onClick={() => navigate("/teamList")}
        />{" "}
        Back
        <div
          className="d-flex justify-content-between align-items-center px-4 py-3 mb-4"
          style={{ backgroundColor: "#F5FCFE" }}
        >
          <div className="d-flex align-items-center gap-3 col-4">
            <h4 className="fw-semibold mb-0">{teamName}</h4>
          </div>
          <span className="text-muted fw-medium col-8 align-items-start">
            Members: {teamMembers?.length}
          </span>
        </div>
        {/* Main Content */}
        <div className="row g-4 px-4">
          {/* Left Column: Owner Info + Timestamps */}
          <div className="col-md-4">
            <div className="mb-4">
              {/* <h6 className="fw-semibold mb-3">Team Owner</h6> */}
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  backgroundColor: "#F5F5F5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Icon
                  icon="proicons:person"
                  width="28"
                  height="28"
                  color="#909090"
                />
              </div>
              {/* Owner text stack */}
              <div
                className=" border p-3 mt-3"
                style={{ backgroundColor: "#F5F5F5", borderRadius: "10px" }}
              >
                <p
                  className="mb-1"
                  style={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    color: "#1F2937",
                  }}
                >
                  {teamOwner.firstName} {teamOwner.lastName}{" "}
                  <span className="text-muted" style={{ fontWeight: 500 }}>
                    Team Owner
                  </span>
                </p>

                <p
                  className="mb-1"
                  style={{ fontSize: "0.95rem", color: "#6B7280" }}
                >
                  {teamOwner.officeEmail}
                </p>

                <p
                  className="mb-0"
                  style={{ fontSize: "0.95rem", color: "#6B7280" }}
                >
                  {teamOwner.mobileNumber}
                </p>
              </div>
            </div>

            {/* Created on (no card, no shadow) */}
            <div className="mb-3">
              <p className="mb-1" style={{ fontWeight: 600, color: "#909090" }}>
                Created on
              </p>
              <p
                className="mb-0 "
                style={{ fontSize: "0.95rem", color: "#909090" }}
              >
                {formatDateTime(createdAt)}
              </p>
            </div>

            {/* Last Updated (no card, no shadow) */}
            <div style={{}}>
              <p className="mb-1" style={{ fontWeight: 600, color: "#909090" }}>
                Last Updated
              </p>
              <p
                className="mb-0 "
                style={{ fontSize: "0.95rem", color: "#909090" }}
              >
                {formatDateTime(updatedAt)}
              </p>
            </div>
          </div>

          {/* Right Column: Team Members */}
          <div className="col-md-8">
            {/* <h5 className="fw-semibold mb-3">Team Members</h5> */}
            <div className="row g-3">
              {teamMembers.map((member, index) => (
                <div key={index} className="col-md-12">
                  <div
                    className="border p-3 bg-white  d-flex align-items-start gap-3 h-100"
                    style={{ borderRadius: "10px", maxWidth: "540px" }}
                  >
                    {/* Circular Icon Wrapper */}
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        backgroundColor: "#F5F5F5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <Icon
                        icon="proicons:person"
                        width="28"
                        height="28"
                        color="#909090"
                      />
                    </div>

                    <div>
                      <p className="mb-1 fw-semibold">
                        {" "}
                        {member.firstName} {member.lastName}
                      </p>
                      <div className=" d-flex gap-2">
                        <p
                          className="mb-1 text-muted"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {member.officeEmail}
                        </p>
                        <p
                          className="mb-0 text-muted"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {member.mobileNumber}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default TeamView;
